export default __webpack_public_path__ + "static/media/fibro-consejos_blog.cf395e9c.png";